import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProductCard } from '../components/ProductCard';
import { FinalOffer } from '../components/FinalOffer';
import { Footer } from '../components/Footer';
const products = [{
  title: 'Jorge Rodríguez: Poder, Estrategia y Control Institucional',
  image: 'https://cdn.magicpatterns.com/uploads/uSZzjy5eJjv3ff8YAXy25a/C6821159-3AC5-4A51-AC93-7C70B9B79375.png',
  benefits: ['Línea temporal clara y estructurada', 'Audiolibro para aprender en movimiento', 'Presentación visual con gráficos clave'],
  ctaText: 'Descarga el pack completo de Jorge Rodríguez hoy'
}, {
  title: 'Luisa Ortega Díaz: De Fiscal General a Figura de Ruptura Política',
  image: 'https://cdn.magicpatterns.com/uploads/hEaL3kd5GVLHx7PnpbnyVB/3330CDCE-0A06-437F-9333-0C386E649D73.png',
  benefits: ['Análisis completo de su legado', 'Audiolibro para escuchar en cualquier lugar', 'Presentación visual para repasar los puntos esenciales'],
  ctaText: 'Profundiza en la historia de Luisa Ortega Díaz: Consigue el pack ahora'
}, {
  title: 'Tareck El Aissami: Ascenso, Redes de Poder y Caída Política',
  image: 'https://cdn.magicpatterns.com/uploads/fZJiRGfuw13Qv8Ke7myduc/5FD9D182-0C49-4A0E-BB20-C9E87774F634.png',
  benefits: ['Recorrido neutral de su carrera', 'Audiolibro para aprender de forma práctica', 'Presentación visual con hitos clave'],
  ctaText: 'Accede al pack completo de Tareck El Aissami hoy'
}];
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#0a0a0a]" data-id="element-111">
      <HeroSection data-id="element-112" />

      {/* Divider */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" data-id="element-113" />

      {/* Product Sections */}
      {products.map((product, index) => <div key={product.title} data-id="element-114">
          <ProductCard title={product.title} image={product.image} benefits={product.benefits} ctaText={product.ctaText} reversed={index % 2 === 1} index={index} data-id="element-115" />
          {index < products.length - 1 && <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-800 to-transparent" data-id="element-116" />}
        </div>)}

      {/* Final Offer */}
      <FinalOffer data-id="element-117" />

      {/* Footer */}
      <Footer data-id="element-118" />
    </main>;
}